import {
  MAX_FILE_BYTES,
  MAX_IMAGE_PIXELS,
  type ImageMeta,
} from './collage'
import {
  FilePreflightError,
  hasSupportedRasterFileMetadata,
  inspectRasterFile,
  preflightRasterFile,
  type DecodedImage,
} from '@/shared/image/filePreflight'

const COLLAGE_LIMITS = {
  maxFileBytes: MAX_FILE_BYTES,
  maxImagePixels: MAX_IMAGE_PIXELS,
} as const

export { FilePreflightError }
export type { DecodedImage }

export function hasSupportedCollageFileMetadata(
  file: Pick<File, 'name' | 'type' | 'size'>,
): boolean {
  return hasSupportedRasterFileMetadata(file, COLLAGE_LIMITS)
}

export function preflightCollageFile(file: File): Promise<ImageMeta> {
  return preflightRasterFile(file, COLLAGE_LIMITS)
}

export function inspectCollageFile(
  file: File,
  decode: (source: ImageBitmapSource) => Promise<DecodedImage> = createImageBitmap,
): Promise<ImageMeta> {
  return inspectRasterFile(file, COLLAGE_LIMITS, decode)
}
